export const MIN_DELIVERY_ORDER_AMOUNT_ILS = 129;

export function getDeliveryMinimumMessage(): string {
  return `מינימום להזמנה במשלוח: ${MIN_DELIVERY_ORDER_AMOUNT_ILS} ש"ח`;
}
